/**
 * Вход по ФИО и рабочему телефону (§16.3).
 *
 * ИТ-служба экосистемы «Космос» доступ не даст (директор филиала,
 * 23.09.2026) — рабочий вход на первую очередь: сотрудник называет ФИО и
 * рабочий телефон, сверка со списком, который ведёт филиал сам (админ-
 * раздел, §16.3). Своей страницы входа раньше не было (§16.2 предполагал
 * внешний портал) — теперь она есть, потому что внешнего портала нет.
 */

import { useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { api } from '../api/client'
import { Logo } from './Logo'

export function LoginPage() {
  const [searchParams] = useSearchParams()
  const [fullName, setFullName] = useState('')
  const [phone, setPhone] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [submitting, setSubmitting] = useState(false)

  async function submit(event: React.FormEvent) {
    event.preventDefault()
    setSubmitting(true)
    setError(null)
    try {
      await api.login(fullName, phone)
      const returnTo = searchParams.get('return_to')
      const target = returnTo && returnTo.startsWith('/') && !returnTo.startsWith('//')
        ? returnTo
        : '/clients'
      window.location.href = target
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err))
      setSubmitting(false)
    }
  }

  return (
    <div className="layout">
      <div className="card login-card">
        <div className="login-brand">
          <Logo size={34} />
        </div>
        <h1 style={{ fontSize: 20 }}>Ипотечный ассистент</h1>
        <p className="muted">Вход по ФИО и рабочему телефону</p>

        <form onSubmit={submit}>
          <label className="field-label" htmlFor="full_name">ФИО</label>
          <input
            id="full_name"
            type="text"
            autoComplete="name"
            placeholder="Иванов Иван Иванович"
            value={fullName}
            onChange={(e) => setFullName(e.target.value)}
            required
          />

          <label className="field-label" htmlFor="phone">Рабочий телефон</label>
          <input
            id="phone"
            type="tel"
            autoComplete="tel"
            placeholder="+7 999 123-45-67"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            required
          />

          {error != null && <p className="error">{error}</p>}

          <div className="actions">
            <button className="primary" type="submit" disabled={submitting}>
              {submitting ? 'Проверяю…' : 'Войти'}
            </button>
          </div>
        </form>

        <p className="disclaimer">
          Нет доступа? Обратитесь к руководителю филиала — он добавляет сотрудников
          в список для входа.
        </p>
      </div>
    </div>
  )
}
